(() => {
  const key = 'zeesy_discovery_v1';
  let initialised = false;
  function allowed() { return window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.() === true; }
  function read() {
    try {
      const value = JSON.parse(localStorage.getItem(key) || 'null');
      return value && Array.isArray(value.seen) && Date.now() - value.at < 90 * 86400000 ? value : {seen:[], at:0};
    } catch { return {seen:[], at:0}; }
  }
  function select(pool, seen, seed, limit) {
    const score = handle => {
      let hash = seed;
      for (const char of handle) hash = Math.imul(hash ^ char.charCodeAt(0), 16777619) >>> 0;
      return hash;
    };
    return [...pool].sort((a,b) => Number(seen.includes(a.dataset.handle)) - Number(seen.includes(b.dataset.handle)) || score(a.dataset.handle) - score(b.dataset.handle)).slice(0,limit);
  }
  function run() {
    const consent = allowed();
    if (initialised) return;
    const state = consent ? read() : {seen:[],at:0};
    const returning = state.at > 0;
    document.querySelectorAll('[data-fresh-edit]').forEach(edit => {
      if (!returning && edit.dataset.returningBuyer !== 'true') return;
      const pool = [...edit.querySelectorAll('template[data-fresh-card]')];
      if (!pool.length) return;
      let seed = Math.floor(Date.now() / 86400000);
      if (consent) {
        try {
          const saved = sessionStorage.getItem(key + '_seed');
          seed = saved ? Number(saved) : Math.floor(Math.random() * 2147483647);
          sessionStorage.setItem(key + '_seed', String(seed));
        } catch {}
      }
      let selected = [];
      if (consent) {
        try {
          const handles = JSON.parse(sessionStorage.getItem(key + '_selection') || '[]');
          selected = handles.map(handle => pool.find(card => card.dataset.handle === handle)).filter(Boolean);
        } catch {}
      }
      if (!selected.length) selected = select(pool, state.seen, seed, 4);
      if (consent) {
        try { sessionStorage.setItem(key + '_selection', JSON.stringify(selected.map(card => card.dataset.handle))); } catch {}
      }
      edit.querySelector('[data-fresh-grid]').replaceChildren(...selected.map(card => card.content.cloneNode(true)));
      edit.hidden = false;
      const original = edit.parentElement.querySelector('[data-fresh-original]');
      if (original) original.hidden = true;
      selected.forEach(card => { if (!state.seen.includes(card.dataset.handle)) state.seen.push(card.dataset.handle); });
    });
    if (consent) {
      const product = document.querySelector('[data-discovery-product]')?.dataset.discoveryProduct;
      if (product && !state.seen.includes(product)) state.seen.push(product);
      try { localStorage.setItem(key, JSON.stringify({seen:state.seen.slice(-160),at:Date.now()})); } catch {}
      initialised = true;
    }
  }
  function consentChanged() {
    if (!allowed()) {
      try { localStorage.removeItem(key); sessionStorage.removeItem(key + '_seed'); sessionStorage.removeItem(key + '_selection'); } catch {}
      document.querySelectorAll('[data-fresh-edit]').forEach(edit => {
        if (edit.dataset.returningBuyer !== 'true') {
          edit.hidden = true;
          const original = edit.parentElement.querySelector('[data-fresh-original]');
          if (original) original.hidden = false;
        }
      });
    }
    initialised = false;
    run();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('visitorConsentCollected', consentChanged);
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}], error => { if (!error) run(); });
  }
})();